const keys = {
  token_timestamp: 'tal_token_timestamp'
};

const gData = {
  refreshTokenCount: 0,
  canRefreshToken() {
    if (gData.refreshTokenCount < 1) {
      gData.refreshTokenCount = 1;
      return true;
    }
    return false;
  },
  timeout: 120 * 60000,
  flushInterval: 10 * 60000
};
const storage = window.sessionStorage;
const localStore = window.localStorage;

export function setCookie(cName, value, days) {
  days = days || 1;
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 3600000);
  let domain = window.location.hostname;
  if (domain.indexOf('.laoshibang.com') > -1) {
    domain = 'laoshibang.com';
  }
  document.cookie = `${cName}=${escape(value)};${days ? `expires=${d.toUTCString()};` : ''}path=/;domain=${domain};SameSite=None;Secure`;
  localStore.setItem(`global.${cName}`, value);
}

export function initDeviceId() {
  window.TAL_UC.getDeviceInfo({
    success: (res) => {
      const deviceId = res.data['device-id'] || '';
      sessionStorage.setItem('X-Device-Id', deviceId);
      setCookie('X-Device-Id', deviceId, 300);
    },
    fail: (error) => {
      console.error(error);
    }
  });
}
export function getCookie(cName) {
  const cookieToken = getOrginCookie(cName);
  return cookieToken;
}

export function getOrginCookie(cName) {
  let cookie = '';
  if (document.cookie.length > 0) {
    let start = document.cookie.indexOf(cName + '=');
    if (start !== -1) {
      start = start + cName.length + 1;
      let end = document.cookie.indexOf(';', start);
      if (end === -1) {
        end = document.cookie.length;
      }
      cookie = unescape(document.cookie.substring(start, end));
    }
  }
  return cookie;
}

// 保存token
export function saveToken(name, token, day) {
  if (!token) {
    return;
  }
  // 服务器5分钟过期 本地存储为4.5分钟后过期
  const expries = Date.now() + gData.timeout;
  storage.setItem(`${name}_expries`, expries);
  setCookie(name, token, day);
  setCookie(keys.token_timestamp, Date.now(), day);
}

// function updateTokenExpries() {
//   const expries = Date.now() + gData.timeout;
//   storage.setItem('tal_token_expries', expries);
// }

export function clearToken(msg) {
  console.log(`============${msg || ''}-清空token!============`);
  storage.setItem('tal_token_expries', '');
  setCookie(keys.token_timestamp, '', 0);
  setCookie('tal_token', '', 0);
  localStorage.removeItem('is_display_trial_tips');
}

// 删除token
export function delToken() {
  clearToken();
}

// 查询token
export function getLocalToken(type) {
  return getCookie(type) || '';
}

export function flushToken() {
  return new Promise((resolve, reject) => {
    getTokenFlush().then((res) => {
      const { tal_token	} = res.data || {};
      saveToken('tal_token', tal_token, 30);
      resolve(tal_token);
    }, (e) => reject(e));
  });
}
